import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Phone = function Phone(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M8.3803 8.8534c.696 1.4496 1.6448 2.8082 2.8463 4.0098 1.2016 1.2016 2.5603 2.1504 4.0099 2.8464.1247.0598.187.0898.2659.1128.2804.0817.6246.023.862-.147.0669-.0479.124-.105.2383-.2193.3496-.3497.5244-.5245.7002-.6387a2 2 0 0 1 2.1804 0c.1758.1142.3506.289.7002.6387l.1948.1948c.5315.5315.7972.7972.9415 1.0826a2 2 0 0 1 0 1.8054c-.1443.2853-.41.5511-.9415 1.0825l-.1576.1576c-.5296.5297-.7944.7945-1.1545.9967-.3995.2244-1.02.3858-1.4782.3844-.4129-.0012-.6952-.0813-1.2596-.2415-3.0334-.861-5.8958-2.4854-8.2837-4.8734-2.388-2.388-4.0125-5.2504-4.8735-8.2838-.1602-.5644-.2403-.8466-.2415-1.2596-.0014-.4582.16-1.0787.3844-1.4782.2023-.36.467-.6248.9967-1.1545l.1576-.1576C5 3.1801 5.2656 2.9143 5.551 2.77a2 2 0 0 1 1.8054 0c.2853.1443.551.41 1.0825.9415l.1949.1949c.3496.3496.5244.5244.6387.7002a2 2 0 0 1 0 2.1803c-.1143.1758-.2891.3506-.6387.7002-.1143.1143-.1715.1715-.2193.2383-.17.2374-.2287.5817-.147.862.023.079.053.1413.1128.266"
    })
  }));
};
export default Phone;